export default "__VITE_ASSET__0b90b9cf__"